<template>
	<div class="level">
		<div class="level-left">
			<h1 class="title" :class="size">
				<dc-icon v-if="icon" :icon="icon" no-margin></dc-icon>
				{{ heading }}
			</h1>
		</div>
		<div class="level-right">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		heading: {
			type: String,
			default: () => null
		},
		icon: {
			type: String,
			default: () => null
		},
		size: {
			type: String,
			default: () => null
		}
	}
};
</script>
